var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealestateimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;}.cls-1,.cls-2,.cls-4{stroke-miterlimit:10;stroke-width:2px;}.cls-2,.cls-3{fill:#fff;}.cls-2,.cls-4{stroke:#8e8e8e;}.cls-4{fill:#8e8e8e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.89 69.98 60.23 52.65 97.55 69.98 97.55 113.83 21.89 113.83 21.89 69.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.72,40.31,11.36,62.72V74.54a1.12,1.12,0,0,1,.38-.07h.06L59.69,52l48.39,22.71V63.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 59.72,
    cy: 68.48,
    r: 6.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "41.68 113.83 41.68 85.84 78.76 85.84 78.76 113.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.94 52.65 75.94 40.31 88.32 40.31 88.32 60.09 75.94 52.65"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.44,9.82C36.3,11,56.09,17,60.83,28.53c4.85,11.84-8.09,24.66-32.66,31.56"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.91 26.49 26.48 75.95 33.81 85.58 41.71 77.04 41.76 70.56 37.42 66.18 41.83 62.93 37.66 59.3 41.89 55.61 37.47 51.16 42.13 44.31 42.31 22.87 26.91 26.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.06,
    y1: 30.19,
    x2: 31.06,
    y2: 72.98
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.31,
    cy: 16.76,
    r: 14.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 34.31,
    cy: 16.76,
    rx: 13.39,
    ry: 13.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 34.31,
    cy: 9.56,
    r: 4.31
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestateimage);
export default __webpack_public_path__ + "static/media/realestateimage.0d2cb45469b4538161ae4a92bfe590b3.svg";
export { ForwardRef as ReactComponent };